import { useState } from 'react';
import { Loader2, RotateCcw } from 'lucide-react';
import { pageKeyFromRoute, trackFeatureAction } from '../lib/usageTracking';

interface DashboardQueryActionsProps {
  loading?: boolean;
  onQuery: () => void;
  onReset?: () => void;
  className?: string;
  showReset?: boolean;
  queryLabel?: string;
  queryTitle?: string;
  /** 页面已有更细粒度的查询/重置埋点时关闭，避免重复记录。 */
  tracking?: boolean;
}

/**
 * 数据看板统一的手动筛选操作。重置会恢复默认条件并触发默认查询。
 */
export function DashboardQueryActions({
  loading = false,
  onQuery,
  onReset,
  className,
  showReset = true,
  queryLabel = '查询',
  queryTitle,
  tracking = true,
}: DashboardQueryActionsProps) {
  const [submitting, setSubmitting] = useState(false);
  const busy = loading || submitting;
  const withFeedback = (action: () => void, actionName: 'query' | 'reset') => {
    setSubmitting(true);
    if (tracking) {
      const route = window.location.pathname;
      void trackFeatureAction({
        page_key: pageKeyFromRoute(route),
        feature_key: 'page_filter',
        action: actionName,
        route,
        properties: { control: 'dashboard_query_actions' },
      });
    }
    action();
    // 某些报表由子区块请求，父级没有可汇总的 loading；保留与渠道宽表一致的明确点击反馈。
    window.setTimeout(() => setSubmitting(false), 400);
  };
  return (
    <div className={className} style={{ display: 'flex', alignItems: 'center', gap: 8, marginLeft: 'auto' }}>
      {showReset && onReset && (
        <button type="button" className="btn btn-outline btn-sm" data-usage-tracked="true" onClick={() => withFeedback(onReset, 'reset')} disabled={busy} style={{ display: 'inline-flex', alignItems: 'center', gap: 5 }}>
          <RotateCcw size={13} />
          重置
        </button>
      )}
      <button type="button" className="btn btn-primary btn-sm" data-usage-tracked="true" onClick={() => withFeedback(onQuery, 'query')} disabled={busy} title={queryTitle}>
        {busy ? <><Loader2 size={14} style={{ animation: 'spin .8s linear infinite' }} />查询中…</> : queryLabel}
      </button>
    </div>
  );
}
